export enum SSOResponseCode {
  /** SSO endpoint reports the user is logged in is & authorized. */
  SUCCESS = 200,

  /** SSO endpoint reports the user is not logged in. */
  NOT_LOGGED_IN = 401,

  /** SSO endpoint reports the user is logged in, but not authorized (i.e. signing Mosaic contracts, etc.). */
  NOT_AUTHORIZED = 403,

  /** No valid tenants associated for the user or the user is disabled. This is determined by the env-admin API. */
  NO_VALID_TENANTS = 900,

  /** Request to Axinom Portal or Env-Admin API failed. Either client request error, server error or CORS error. */
  REQUEST_FAILED = 901,
}

export interface SSOToken {
  token?: string;
  parsedToken?: ParsedSSOToken;
}

export interface ParsedSSOToken {
  code: number;
  email: string;
  error: string;
}
